import Controller from '~/controllers/application_controller';

export default class extends Controller {
  connect() {
    const turnstileElement = this.element.querySelector('.cf-turnstile');
    window.turnstile.remove();
    window.turnstile.render(turnstileElement);
  }
}
